import proj4 from 'proj4';
import { type ReactElement } from 'react';
import { toWgs84 } from 'reproject';
import { affectedArea, bikeSituation, roadSituation } from '../LayerFactories';
import { LeafletMap } from '../Map';

import type { Map } from 'leaflet';
import type { PageMapProps } from './types';

interface NewsArticlePageMapProps extends PageMapProps {
    pageId: number;
    sweref99GeoArea: string;
    showRoadSituations: boolean;
    showBikeSituations: boolean;
}

export const NewsArticlePageMap = (props: NewsArticlePageMapProps): ReactElement => {
    const mapProps = props.mapSettings;
    const setupMap = (map: Map): void => {
        const region = mapProps.region.toLowerCase();

        if (props.sweref99GeoArea === null) {
            return;
        }
        const area = toWgs84(JSON.parse(props.sweref99GeoArea), '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs', proj4);

        const areaLayer = affectedArea(area, {
            style: {
                fillColor: '#098cc8',
                fillOpacity: 0.2,
                stroke: true,
                color: '#098cc8',
                opacity: 0.5,
                weight: 2,
                interactive: false,
            },
        }).addTo(map);

        if (props.showRoadSituations) {
            roadSituation(region, props.pageId).addTo(map);
        }
        if (props.showBikeSituations) {
            bikeSituation(region, props.pageId).addTo(map);
        }

        map.fitBounds(areaLayer.getBounds());
    };

    return <LeafletMap {...mapProps} disableFullscreenControl={true} onMapInitiated={setupMap} />;
};
